"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
var debug = false;
var EventEmitter = /** @class */ (function () {
    function EventEmitter(debugName) {
        this.listeners = [];
        this.debugName = debugName !== null && debugName !== void 0 ? debugName : (EventEmitter.counter++).toString();
    }
    EventEmitter.prototype.log = function (message, opts) {
        if (!debug)
            return;
        console.log('Emitter', this.debugName, message, opts);
    };
    EventEmitter.prototype.warn = function (message) {
        if (!debug)
            return;
        console.warn('Emitter', this.debugName, message);
    };
    EventEmitter.prototype.subscribe = function (callback) {
        var obj = { callback: callback, removed: false };
        this.listeners.push(obj);
        var self = this;
        return {
            cancel: function () {
                var preLength = self.listeners.length;
                obj.removed = true; // mark as removed in case emit() is being called
                self.listeners = self.listeners.filter(function (l) { return l !== obj; });
                if (self.listeners.length === preLength) {
                    self.warn('listener already removed');
                    return;
                }
            },
        };
    };
    EventEmitter.prototype.subscribeAndFireLast = function (callback) {
        var sub = this.subscribe(callback);
        if (this.lastValue !== undefined) {
            callback(this.lastValue);
        }
        return sub;
    };
    EventEmitter.prototype.emit = function (value) {
        this.listeners.map(function (item) {
            if (item.removed)
                return null;
            item.callback(value);
            return null;
        });
        this.lastValue = value;
    };
    EventEmitter.counter = 0;
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
